import { getRequiredVariablesFromTemplate } from '../engagement-templates/utils';
import escapeHtml from './utils/escape-html';

/**
 * Runs variable validation and if successful calls the provided function and
 * wraps it in a result object, otherwise returns a failure.
 */
function withVariableValidation(template, variables, fn) {
  var requiredKeys = getRequiredVariablesFromTemplate(template);
  var missingKeys = requiredKeys.filter(function (variableName) {
    return !variables[variableName];
  });
  if (missingKeys.length) {
    return {
      type: 'error',
      errorType: 'missing-variables-error',
      missingVariables: missingKeys
    };
  }
  return {
    type: 'success',
    result: fn(template, variables)
  };
}

/**
 * Replaces variables onto a template, using the provided escaping function.
 */
function rawReplaceVariables(template, variables, escapeFn) {
  return template.parts.map(function (templatePart) {
    if (templatePart.type === 'text') {
      return templatePart.text;
    }
    if (templatePart.type === 'escaped') {
      return escapeFn(variables[templatePart.variableName]);
    }
    return variables[templatePart.variableName];
  }).join('');
}

/**
 * Without validation, runs a template with URI escaping.
 */
function rawReplaceVariablesForUrl(template, variables) {
  return rawReplaceVariables(template, variables, encodeURIComponent);
}

/**
 * Without validation, runs a template with HTML escaping.
 */
function rawReplaceVariablesForHtml(template, variables) {
  return rawReplaceVariables(template, variables, escapeHtml);
}

/**
 * Validates variables and runs a template with URI escaping.
 */
export function replaceForUrl(template, variables) {
  return withVariableValidation(template, variables, rawReplaceVariablesForUrl);
}

/**
 * Validates variables and runs a template with HTML escaping.
 */
export function replaceForHtml(template, variables) {
  return withVariableValidation(template, variables, rawReplaceVariablesForHtml);
}